<template>
  <div class="wjt-pay-page">
    <div class="wjt-pay-wrapper">
      <div class="wjt-pay-topbar">
        <button class="wjt-back-btn" @click="goBack">
          <i class="el-icon-back"></i>返回
        </button>
        <h1 class="wjt-pay-title">收银台</h1>
      </div>

      <section class="wjt-pay-card">
        <!-- 头部：状态 + 金额 -->
        <div class="wjt-pay-header">
          <div class="wjt-pay-header-left">
            <div :class="['wjt-status-icon', orderAviliable ? '' : 'wjt-status-icon-done']">
              <i :class="orderAviliable ? 'el-icon-lock' : 'el-icon-check'"></i>
            </div>
            <div class="wjt-status-text">
              <h2>{{ orderAviliable ? '订单提交成功，请尽快付款' : '订单已超时，请重新下单' }}</h2>
              <p class="wjt-order-no">订单号：{{ orderInfo.deliveryOrderId }}</p>
              <p class="wjt-countdown" v-if="orderAviliable">
                请在 <b>{{ countDownHour }}时{{ countDownMinute }}分{{ countDownSecond }}秒</b> 内完成支付，超时订单将自动取消。
              </p>
            </div>
          </div>
          <div class="wjt-amount-box" v-if="orderAviliable">
            <p class="wjt-amount-label">应付金额</p>
            <p class="wjt-amount-value">¥ {{ orderInfo.sumPrice }}<span class="wjt-amount-unit">元</span></p>
          </div>
        </div>

        <!-- 支付方式 -->
        <div class="wjt-pay-body" v-if="orderAviliable">
          <div class="wjt-section-title">
            <span class="wjt-step-badge">01</span>
            <h3>选择支付方式</h3>
          </div>

          <div class="wjt-method-list">
            <div
              v-for="channel in channels"
              :key="channel.channelId"
              :class="['wjt-method-card', currentChannel === channel.channelId ? 'wjt-method-selected' : '']"
              @click="currentChannel = channel.channelId"
            >
              <span :class="['wjt-method-icon', 'wjt-icon-' + channel.channelId]">
                <img :src="`/static/image/${channel.channelId}.png`" />
              </span>
              <span class="wjt-method-info">
                <span class="wjt-method-name">{{ channel.channelName }}</span>
                <span class="wjt-method-desc" v-if="channel.channelId == 'fast_pay' && bankNoText.length > 0">{{ bankNoText }}</span>
                <span class="wjt-method-desc" v-else>{{ channel.channelId == 'alipay_qr' ? '使用支付宝扫描二维码完成付款' : (channel.channelId == 'wx_pub' ? '通过微信安全完成支付' : '使用已绑定的银行卡快捷支付') }}</span>
              </span>
              <span :class="['wjt-method-check', currentChannel === channel.channelId ? 'wjt-method-check-on' : '']">
                <i class="el-icon-check" v-if="currentChannel === channel.channelId"></i>
              </span>
            </div>
          </div>

          <div class="wjt-bindbank-row">
            <button class="wjt-bindbank-btn" @click="toAddBank">
              <i :class="hasBankCard ? 'el-icon-edit' : 'el-icon-plus'"></i>
              {{ hasBankCard ? '换卡支付' : '绑定银行卡支付' }}
            </button>
          </div>

          <div class="wjt-pay-action">
            <button class="wjt-pay-btn" @click="pay">
              <i class="el-icon-lock"></i>立即支付 ¥{{ orderInfo.sumPrice }}
            </button>
            <p class="wjt-agreement">支付即表示同意《关盈堂支付服务协议》</p>
          </div>
        </div>
      </section>

      <el-dialog
        title="绑定银行卡"
        :visible.sync="bankDialogVisible"
        center
        destroy-on-close
        width="860px"
        :close-on-press-escape="false"
      >
        <el-form
          label-width="200px"
          label-position="right"
          class="dialog"
          :model="bindBankInfo"
        >
          <div
            style="
              width: 100%;
              margin-bottom: 30px;
              font-size: 18px;
              color: #666;
              text-align: left;
              padding-left: 20px;
            "
          >
            <p>温馨提示：</p>
            <p>
              1、请绑定工商银行、农业银行、中国银行、建设银行、交通银行的储蓄卡。
            </p>
            <p>2、不支持绑定信用卡。</p>
          </div>
          <el-form-item class="form-item" label="*银行卡号：">
            <el-input
              v-model="bindBankInfo.cardId"
              type="number"
              autocomplete="off"
              placeholder="请输入银行卡号"
            ></el-input>
          </el-form-item>
          <el-form-item label="*姓名：" class="form-item">
            <el-input
              v-model="bindBankInfo.userName"
              type="text"
              autocomplete="off"
              placeholder="请输入银行卡用户姓名"
            ></el-input>
          </el-form-item>
          <el-form-item label="*身份证号码：" class="form-item">
            <el-input
              v-model="bindBankInfo.idNo"
              type="text"
              autocomplete="off"
              placeholder="请输入身份证号码"
            ></el-input>
          </el-form-item>
          <el-form-item label="*银行手机号：" class="form-item">
            <el-input
              v-model="bindBankInfo.telNo"
              type="text"
              autocomplete="off"
              placeholder="请输入银行卡绑定手机号码"
            ></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button
            @click="bankDialogVisible = false"
            style="margin-right: 30px"
            >取消</el-button
          >
          <el-button type="primary" @click="bindBank" style="margin-left: 30px"
            >绑定</el-button
          >
        </span>
      </el-dialog>
      <el-dialog
        title="绑定银行卡验证"
        :visible.sync="bindCodeDialogVisible"
        center
        destroy-on-close
        width="880px"
        :close-on-press-escape="false"
      >
        <div class="dialog">
          <img
            src="/static/image/ic_phone.png"
            style="width: 60px; height: 60px"
          />
          <span style="color: #333333; font-size: 22px; margin-top: 20px"
            >使用手机验证码</span
          >
          <span style="color: #666666; font-size: 18px; margin-top: 10px"
            >当前手机号{{ bindBankInfo.telNo }}</span
          >
          <div
            class="row-container"
            style="
              margin-top: 30px;
              align-items: center;
              justify-content: center;
            "
          >
            <el-input
              style="width: 60%"
              placeholder="输入验证码"
              v-model="verify_code"
              maxlength="6"
              clearable
            ></el-input>
            <el-button
              style="width: 40%; margin-left: 20px"
              class="btn-verify"
              size="medium"
              @click="bindBank"
              type="primary"
              :loading="vloading"
              :disabled="verify_disable"
              >{{ btn_verify }}</el-button
            >
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="bindConfirm">绑定</el-button>
        </span>
      </el-dialog>
      <el-dialog
        title="支付验证"
        :visible.sync="payCodeDialogVisible"
        center
        destroy-on-close
        width="750px"
        :close-on-press-escape="false"
        :before-close="beforeClose"
      >
        <div class="dialog">
          <img
            src="/static/image/ic_phone.png"
            style="width: 60px; height: 60px"
          />
          <span style="color: #333333; font-size: 22px; margin-top: 20px"
            >使用手机验证码</span
          >
          <span style="color: #666666; font-size: 18px; margin-top: 10px"
            >当前手机号{{ fastPayInfo.telNo }}</span
          >
          <div
            class="row-container"
            style="
              margin-top: 30px;
              align-items: center;
              justify-content: center;
            "
          >
            <el-input
              style="width: 60%"
              placeholder="输入验证码"
              v-model="pay_verify_code"
              maxlength="6"
              clearable
            ></el-input>
            <el-button
              style="width: 40%; margin-left: 20px"
              class="btn-verify"
              size="medium"
              @click="getPayVerifyCode"
              type="primary"
              :loading="pay_vloading"
              :disabled="pay_verify_disable"
              >{{ pay_btn_verify }}</el-button
            >
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="payConfirm">认证支付</el-button>
          </span>
        </div>
      </el-dialog>
      <el-dialog
        :title="currentChannel == 'alipay_qr' ? '支付宝支付' : '微信支付'"
        :visible.sync="qrcodeVisble"
        width="400px"
        :close-on-click-modal="dialogClosable"
        :close-on-press-escape="false"
        :before-close="beforeClose"
      >
        <div class="dialog-wrapper" v-if="currentChannel == 'alipay_qr'">
          <img :src="qrCode" style="width: 200px; height: 200px" />
        </div>
        <div class="dialog-wrapper" v-else>
          <div id="wjtWxQrCode"></div>
          <span class="wjt-qr-refresh-text">二维码过期了？<b @click="qrcodeRefresh">立即刷新</b></span>
        </div>
      </el-dialog>
      <el-dialog
        title="支付中..."
        :visible.sync="fastPayStatusVisble"
        width="400px"
        :close-on-click-modal="fastDialogClosable"
      >
        <div
          class="dialog-wrapper"
          v-loading="loading"
          element-loading-text="正在获取支付结果..."
          element-loading-spinner="el-icon-loading"
        ></div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import AreaHeader from "@/components/widgets/area-header.vue";
import QRCode from "qrcodejs2";
export default {
  components: {
    AreaHeader,
  },
  data() {
    return {
      orderInfo: {},
      countDownHour: "00",
      countDownMinute: "00",
      countDownSecond: "00",
      currentChannel: "",
      bankDialogVisible: false,
      bindCodeDialogVisible: false,
      btn_verify: "获取验证码",
      verify_disable: false,
      codeDialogType: 0,
      verify_second: 60,
      verify_status: true,
      verify_code: "",
      vloading: false,
      payCodeDialogVisible: false,
      pay_btn_verify: "获取验证码",
      pay_verify_disable: false,
      pay_verify_second: 60,
      pay_verify_status: true,
      pay_verify_code: "",
      pay_vloading: false,
      pay_mInterval: {},
      hasBankCard: false,
      bindBankInfo: {
        cardId: "",
        idNo: "",
        telNo: "",
        userName: "",
      },
      fastPayInfo: {
        telNo: "",
      },
      bankNoText: "",
      toAddBankText: "",
      channels: [],
      zfbInterval: {},
      payInterval: {},
      payStatusCount: 0,

      qrCode: {},
      wxQrCode: null,
      qrcodeVisble: false,
      outTradeNo: "",
      dialogClosable: false,
      fastDialogClosable: false,
      fastPayStatusVisble: false,
      orderAviliable: true,
      loading: true,
      memberId: "",
      cardIdReal: "",
    };
  },
  created() {
    console.log(process.env.DOMAIN_URL);
    this.orderInfo = JSON.parse(
      sessionStorage.getItem("fulfillmentPlaceOrderInfo")
    );
    this.startCountDown();
    this.getPayChannels();
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    startCountDown() {
      var timeMill = this.orderInfo.payCountdown;
      var currentTimeMill = Date.parse(new Date());
      console.log("netMill:" + timeMill);
      console.log("currentMill:" + currentTimeMill);
      if (currentTimeMill > timeMill) {
        return;
      }
      var totalSecond = (timeMill - currentTimeMill) / 1000;
      console.log("countdown:" + totalSecond);
      var that = this;
      this.interval = setInterval(function () {
        // 秒数
        var second = totalSecond;
        // 小时位
        var hr = Math.floor(second / 3600);
        var hrStr = hr.toString();
        if (hrStr.length == 1) hrStr = "0" + hrStr;

        // 分钟位
        var min = Math.floor((second - hr * 3600) / 60);
        var minStr = min.toString();
        if (minStr.length == 1) minStr = "0" + minStr;

        // 秒位
        var sec = second - hr * 3600 - min * 60;
        var secStr = sec.toString();
        if (secStr.length == 1) secStr = "0" + secStr;
        that.countDownHour = hrStr;
        that.countDownMinute = minStr;
        that.countDownSecond = secStr;
        totalSecond--;
        if (totalSecond < 0) {
          clearInterval(that.interval);
          console.log("倒计时结束");
          that.countDownHour = "00";
          that.countDownMinute = "00";
          that.countDownSecond = "00";
          this.orderAviliable = false;
        }
      }, 1000);
    },
    getPayChannels() {
      this.wjtHttp.get(
        this,
        "/api/adapay/v1/channels/pc",
        {},
        true,
        (res) => {
          var data = res.data;
          if (data.code == 200) {
            this.dialogVisible = true;
            this.channels = data.data;
            var fastPay = this.channels.find(
              (item) => item.channelId == "fast_pay"
            );
            if (fastPay != null) {
              this.getFastPayInfo();
            }
          } else {
            this.$message({
              message:
                data.msg && data.msg.length > 0 ? data.msg : "获取支付渠道异常",
              type: "error",
            });
          }
        },
        (err) => {
          console.log(err);
        }
      );
    },
    qrcodeRefresh() {
      if (this.currentChannel == "wx_pub") {
        // payUrl 有效期约5分钟，过期后重调下单接口重新获取（后端幂等返回）
        this.payApplyOfficial();
      } else {
        this.payApply("alipay_qr");
      }
    },
    beforeClose(done) {
      this.qrcodeVisble = false;
      this.payCodeDialogVisible = false;
      // this.$confirm(
      //   '<span style="font-size:18px; color:#DD3131">如关闭，需等待一分钟后再次打开，请确认是否关闭?</span>',
      //   "提示",
      //   {
      //     confirmButtonText: "确定",
      //     cancelButtonText: "取消",
      //     dangerouslyUseHTMLString: true,
      //     type: "warning",
      //   }
      // )
      //   .then(() => {
      //     this.qrcodeVisble = false;
      //     this.payCodeDialogVisible = false;
      //   })
      //   .catch(() => {});
    },
    //获取绑定的银行卡信息
    getFastPayInfo() {
      this.wjtHttp.get(
        this,
        "/api/adapay/v1/fastpay/card/info",
        {},
        true,
        (res) => {
          var data = res.data;
          if (data.code == 200) {
            if (
              data.data != null &&
              data.data.cardId != null &&
              data.data.cardId.length > 0
            ) {
              this.fastPayInfo = data.data;
              console.log(this.fastPayInfo);
              this.hasBankCard = true;
              this.bankNoText = "  （" + this.fastPayInfo.cardId + "）";
            } else {
              this.hasBankCard = false;
            }
          } else {
            this.$message({
              message:
                data.msg && data.msg.length > 0
                  ? data.msg
                  : "获取账号绑定银行卡信息异常",
              type: "error",
            });
          }
        },
        (err) => {
          console.log(err);
        }
      );
    },

    getPayVerifyCode() {
      var codeParams = {
        deliveryOrderId: this.orderInfo.deliveryOrderId,
      };
      this.pay_vloading = true;
      this.wjtHttp.post(
        this,
        "/api/adapay/v1/fastpay/sms",
        codeParams,
        false,
        (res) => {
          this.pay_vloading = false;
          var data = res.data;
          if (data.code == 200) {
            this.$message({
              message: "发送成功",
              type: "success",
            });
            this.pay_verify_disable = true;
            clearInterval(this.pay_mInterval);
            this.pay_mInterval = setInterval(() => {
              if (this.pay_verify_second == 0) {
                this.pay_verify_disable = false;
                this.pay_verify_second = 60;
                clearInterval(this.pay_mInterval);
                return;
              }
              this.pay_verify_second--;
            }, 1000);
          } else {
            this.$message({
              message:
                data.msg && data.msg.length > 0
                  ? data.msg
                  : "验证码获取失败，请联系管理员",
              type: "error",
            });
          }
        },
        (err) => {
          this.pay_vloading = false;
        }
      );
    },
    //生成支付订单，获取验证码
    payApply(channel) {
      this.wjtHttp.post(
        this,
        "/api/adapay/v1/unifiedOrder",
        {
          deliveryOrderId: this.orderInfo.deliveryOrderId,
          channel: channel,
        },
        false,
        (res) => {
          var data = res.data;
          if (data.code == 200) {
            this.paymentId = data.data.paymentId;
            if (channel == "fast_pay") {
              this.payCodeDialogVisible = true;
              this.pay_verify_disable = true;
              clearInterval(this.pay_mInterval);
              this.pay_mInterval = setInterval(() => {
                if (this.pay_verify_second == 0) {
                  this.pay_verify_disable = false;
                  this.pay_verify_second = 60;
                  clearInterval(this.pay_mInterval);
                  return;
                }
                this.pay_verify_second--;
              }, 1000);
            } else if (channel == "alipay_qr") {
              //支付宝
              this.qrcodeVisble = true;
              var outTradeNo = data.data.alipayQrBase64;
              this.qrCode = "data:image/jpeg;base64," + outTradeNo;
              this.getPayStatus();
            }
          } else {
            this.$message({
              message:
                data.msg && data.msg.length > 0
                  ? data.msg
                  : "支付异常，请联系管理员",
              type: "error",
            });
          }
        },
        (err) => {}
      );
    },
    // 微信公众号主扫支付：获取天阙收银台 payUrl 并渲染聚合二维码
    payApplyOfficial() {
      this.wjtHttp.post(
        this,
        "/api/adapay/v1/unifiedOrderOfficial",
        {
          deliveryOrderId: this.orderInfo.deliveryOrderId,
          channel: "wx_pub",
        },
        false,
        (res) => {
          var data = res.data;
          if (data.code == 200) {
            this.paymentId = data.data.paymentId;
            // 优先使用顶层 payUrl，为空时解析 miniProPayJson 兜底
            var payUrl = data.data.payUrl;
            if (!payUrl || payUrl.length == 0) {
              try {
                var miniPay = data.data.miniProPayJson
                  ? JSON.parse(data.data.miniProPayJson)
                  : null;
                if (miniPay && miniPay.pay_info && miniPay.pay_info.payUrl) {
                  payUrl = miniPay.pay_info.payUrl;
                }
              } catch (e) {
                console.log("解析miniProPayJson失败", e);
              }
            }
            if (!payUrl || payUrl.length == 0) {
              this.$message({
                message: "获取支付链接失败，请重试",
                type: "error",
              });
              return;
            }
            this.qrcodeVisble = true;
            this.$nextTick(() => {
              this.renderWxQrCode(payUrl);
            });
            this.getPayStatus();
          } else {
            this.$message({
              message:
                data.msg && data.msg.length > 0
                  ? data.msg
                  : "支付异常，请联系管理员",
              type: "error",
            });
          }
        },
        (err) => {}
      );
    },
    // 渲染聚合收银台二维码（微信/支付宝/云闪付均可扫）
    renderWxQrCode(payUrl) {
      if (this.wxQrCode != undefined && this.wxQrCode != null) {
        this.wxQrCode.clear();
        this.wxQrCode.makeCode(payUrl);
      } else {
        this.wxQrCode = new QRCode("wjtWxQrCode", {
          text: payUrl,
          width: 200,
          height: 200,
          correctLevel: QRCode.CorrectLevel.H,
        });
      }
    },
    getPayStatus() {
      clearInterval(this.payInterval);
      if (this.zfbInterval != undefined && this.zfbInterval != null) {
        clearInterval(this.zfbInterval);
      }
      this.payStatusCount = 0;
      this.zfbInterval = setInterval(() => {
        this.payStatusCount++;
        if (this.payStatusCount > 60) {
          // 约3分钟仍未查到结果，停止轮询，避免无限请求
          clearInterval(this.zfbInterval);
          this.$message({
            message: "支付结果查询超时，若已付款请稍后在订单中查看支付状态",
            type: "warning",
          });
          return;
        }
        this.wjtHttp.get(
          this,
          "/api/adapay/v1/pay/status/" + this.paymentId,
          {},
          false,
          (res) => {
            var data = res.data;
            if (data.code == 200 && data.data.statusCode == "succeeded") {
              this.$notify({
                title: "成功",
                message: "提交成功",
                type: "success",
                duration: 0,
              });
              setTimeout(() => {
                this.$router.go(-1);
              }, 1000);
              clearInterval(this.zfbInterval);
              this.qrcodeVisble = false;
              this.payCodeDialogVisible = false;
              this.bankDialogVisible = false;
              this.fastPayStatusVisble = false;
            } else if (data.data.statusCode == "failed") {
              this.$notify({
                title: "失败",
                message: data.data.statusDesc
                  ? data.data.statusDesc
                  : "交易失败，请重试",
                type: "error",
                duration: 0,
              });
              clearInterval(this.zfbInterval);
              this.qrcodeVisble = false;
              this.payCodeDialogVisible = false;
              this.bankDialogVisible = false;
              this.fastPayStatusVisble = false;
            }
          },
          (err) => {
            console.log(err);
          }
        );
      }, 3000);
    },
    toAddBank() {
      this.bankDialogVisible = true;
    },
    //申请绑定银行卡（获取验证码）
    bindBank() {
      if (this.bindBankInfo.cardId.length == 0) {
        this.$message("请输入银行卡号");
        return;
      }
      if (this.bindBankInfo.userName.length == 0) {
        this.$message("请输入姓名");
        return;
      }
      if (this.bindBankInfo.idNo.length == 0) {
        this.$message("请输入身份证号码");
        return;
      }
      if (this.bindBankInfo.telNo.length == 0) {
        this.$message("请输入手机号码");
        return;
      }
      this.wjtHttp.post(
        this,
        "/api/adapay/v1/fastpay/card/apply",
        this.bindBankInfo,
        true,
        (res) => {
          var data = res.data;
          if (data.code == 200) {
            this.applyId = data.data.applyId;
            this.memberId = data.data.memberId;
            this.cardIdReal = data.data.cardIdReal;
            // if(data.data.isExist == 2){
            this.bindCodeDialogVisible = true;
            // }
            this.verify_disable = true;
            clearInterval(this.mInterval);
            this.mInterval = setInterval(() => {
              if (this.verify_second == 0) {
                this.verify_disable = false;
                this.verify_second = 60;
                clearInterval(this.mInterval);
                return;
              }
              this.verify_second--;
            }, 1000);
          } else {
            this.$message({
              message:
                data.msg && data.msg.length > 0 ? data.msg : "绑定银行卡异常",
              type: "error",
            });
          }
        },
        (err) => {
          console.log(err);
        }
      );
    },
    bindConfirm() {
      if (this.verify_code.length == 0) {
        this.$message({
          message: "请先输入验证码",
          type: "error",
        });
      }
      this.wjtHttp.post(
        this,
        "/api/adapay/v1/fastpay/card/comfirm",
        {
          applyId: this.applyId,
          memberId: this.memberId,
          smsCode: this.verify_code,
          cardIdReal: this.cardIdReal,
        },
        true,
        (res) => {
          var data = res.data;
          if (data.code == 200) {
            this.bindCodeDialogVisible = false;
            this.bankDialogVisible = false;
            this.getPayChannels();
          } else {
            this.$message({
              message:
                data.msg && data.msg.length > 0 ? data.msg : "绑定银行卡异常",
              type: "error",
            });
          }
        },
        (err) => {
          console.log(err);
        }
      );
    },
    pay() {
      if (this.currentChannel.length == 0) {
        this.$message({
          message: "请选择一个支付渠道",
          type: "error",
        });
        return;
      }
      if (this.currentChannel == "fast_pay") {
        if (
          this.fastPayInfo == null ||
          this.fastPayInfo.cardId == null ||
          this.fastPayInfo.cardId.length == 0
        ) {
          this.bankDialogVisible = true;
        } else {
          this.payApply("fast_pay");
        }
      } else if (this.currentChannel == "alipay_qr") {
        this.payApply("alipay_qr");
      } else if (this.currentChannel == "wx_pub") {
        //微信（公众号主扫：获取天阙收银台链接渲染二维码）
        this.payApplyOfficial();
      }
    },
    //获取验证码后支付按钮
    payConfirm() {
      if (this.pay_verify_code.length == 0) {
        this.$message({
          message: "请输入验证码",
          type: "error",
        });
        return;
      }
      this.wjtHttp.post(
        this,
        "/api/adapay/v1/fastpay/comfirm",
        {
          paymentId: this.paymentId,
          smsCode: this.pay_verify_code,
        },
        true,
        (res) => {
          var data = res.data;
          if (data.code == 200) {
            this.getPayStatus();
            this.fastPayStatusVisble = true;
          } else {
            this.$message({
              message: data.msg && data.msg.length > 0 ? data.msg : "支付异常",
              type: "error",
            });
          }
        },
        (err) => {
          console.log(err);
        }
      );
    },
  },

  watch: {
    verify_disable: function (val) {
      if (val) {
        this.btn_verify = this.verify_second + "后重发";
      } else {
        this.btn_verify = "获取验证码";
      }
    },
    verify_second: function (val) {
      if (val < 60) {
        this.btn_verify = val + "后重发";
      }
    },

    pay_verify_disable: function (val) {
      if (val) {
        this.pay_btn_verify = this.pay_verify_second + "后重发";
      } else {
        this.pay_btn_verify = "获取验证码";
      }
    },
    pay_verify_second: function (val) {
      if (val < 60) {
        this.pay_btn_verify = val + "后重发";
      }
    },
    qrcodeVisble: function (val) {
      if (!val && this.zfbInterval != null && this.zfbInterval != undefined) {
        clearInterval(this.zfbInterval);
        clearInterval(this.payInterval);
      }
    },
    fastPayStatusVisble: function (val) {
      if (!val && this.zfbInterval != null && this.zfbInterval != undefined) {
        clearInterval(this.zfbInterval);
      }
    },
  },
  destroyed() {
    clearInterval(this.mInterval);
    clearInterval(this.pay_mInterval);
    clearInterval(this.zfbInterval);
    clearInterval(this.payInterval);
  },
};
</script>

<style scoped>
/* 覆盖 Element UI 默认蓝色为主题绿色 */
.wjt-pay-page ::v-deep .el-input__inner:focus,
.wjt-pay-page ::v-deep .el-textarea__inner:focus {
  border-color: #009798 !important;
  box-shadow: 0 0 0 2px rgba(0, 151, 152, 0.12) !important;
}
.wjt-pay-page ::v-deep .el-button--primary {
  background-color: #009798 !important;
  border-color: #009798 !important;
}
.wjt-pay-page ::v-deep .el-button--primary:hover,
.wjt-pay-page ::v-deep .el-button--primary:focus {
  background-color: #007e7f !important;
  border-color: #007e7f !important;
}
.wjt-pay-page ::v-deep .el-radio__input.is-checked .el-radio__inner {
  background-color: #009798 !important;
  border-color: #009798 !important;
}
.wjt-pay-page ::v-deep .el-radio__input.is-checked + .el-radio__label {
  color: #009798 !important;
}
</style>

<style scoped>
.wjt-pay-page {
  min-height: 100vh;
  padding: 40px 24px 60px;
  background: radial-gradient(circle at 83% 12%, rgba(236,218,163,0.22), transparent 24%),
              linear-gradient(120deg, #eef8f6 0%, #fbfdfb 55%, #eff8f3 100%);
  font-family: '思源黑体', 'Source Han Sans SC', 'Noto Sans SC', system-ui, sans-serif;
  color: #304744;
}

.wjt-pay-wrapper {
  max-width: 1120px;
  margin: 0 auto;
}

/* 顶部导航 */
.wjt-pay-topbar {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 32px;
}
.wjt-back-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  height: 44px;
  padding: 0 24px;
  border-radius: 999px;
  border: 1px solid #c7dcd8;
  background: #fff;
  font-size: 15px;
  font-weight: 600;
  color: #009798;
  cursor: pointer;
  transition: background 0.2s;
}
.wjt-back-btn:hover { background: #f3f9f8; }
.wjt-pay-title {
  font-size: 26px;
  font-weight: 700;
  color: #304744;
  margin: 0;
}

/* 主卡片 */
.wjt-pay-card {
  overflow: hidden;
  border-radius: 30px;
  border: 1px solid rgba(23, 61, 59,0.10);
  background: #fff;
  box-shadow: 0 14px 35px rgba(23, 61, 59,0.08);
}

/* 卡片头部 */
.wjt-pay-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  padding: 32px 40px;
  border-bottom: 1px solid rgba(23, 61, 59,0.10);
  background: #fbfdfb;
}
.wjt-pay-header-left {
  display: flex;
  gap: 16px;
  align-items: flex-start;
}
.wjt-status-icon {
  flex-shrink: 0;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: #eaf6f4;
  color: #007e7f;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
}
.wjt-status-icon-done {
  background: #009798;
  color: #fff;
}
.wjt-status-text h2 {
  font-size: 23px;
  font-weight: 700;
  color: #304744;
  margin: 0 0 4px 0;
}
.wjt-order-no {
  font-size: 14px;
  color: #94a3b8;
  margin: 0;
}
.wjt-countdown {
  font-size: 14px;
  color: #a45c35;
  margin: 4px 0 0 0;
}
.wjt-countdown b { color: #d45a38; font-weight: 700; }

/* 金额框 */
.wjt-amount-box {
  flex-shrink: 0;
  text-align: right;
  padding: 12px 20px;
  border-radius: 16px;
  border: 1px solid #f0dccb;
  background: #fffaf5;
}
.wjt-amount-label {
  font-size: 12px;
  font-weight: 600;
  color: #95674d;
  margin: 0 0 4px 0;
}
.wjt-amount-value {
  font-size: 34px;
  font-weight: 700;
  line-height: 1;
  color: #d45a38;
  margin: 0;
}
.wjt-amount-unit {
  font-size: 14px;
  font-weight: 500;
  margin-left: 4px;
}

/* 支付主体 */
.wjt-pay-body {
  padding: 40px;
}
.wjt-section-title {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 28px;
}
.wjt-step-badge {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #eaf6f4;
  color: #007e7f;
  font-size: 12px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
}
.wjt-section-title h3 {
  font-size: 21px;
  font-weight: 700;
  color: #304744;
  margin: 0;
}

/* 支付方式卡片 */
.wjt-method-list {
  max-width: 760px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.wjt-method-card {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 20px;
  border-radius: 16px;
  border: 1px solid #e2e8f0;
  background: #fff;
  cursor: pointer;
  transition: all 0.2s;
}
.wjt-method-card:hover { border-color: #c7dcd8; }
.wjt-method-selected {
  border-color: #009798;
  background: #f5fbf7;
  box-shadow: 0 6px 18px rgba(0, 151, 152,0.08);
}
.wjt-method-icon {
  flex-shrink: 0;
  width: 44px;
  height: 44px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.wjt-method-icon img { width: 24px; height: 24px; object-fit: contain; }
.wjt-icon-alipay_qr { background: #e5f4ff; }
.wjt-icon-fast_pay { background: #edf4fb; }
.wjt-icon-wx_pub { background: #eaf6f4; }

.wjt-method-info {
  flex: 1;
  display: flex;
  flex-direction: column;
}
.wjt-method-name {
  font-size: 16px;
  font-weight: 700;
  color: #304744;
}
.wjt-method-desc {
  margin-top: 4px;
  font-size: 14px;
  color: #94a3b8;
}
.wjt-method-check {
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 1px solid #cbd5e1;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: #fff;
}
.wjt-method-check-on {
  border-color: #009798;
  background: #009798;
}

/* 绑定银行卡按钮 */
.wjt-bindbank-row {
  max-width: 760px;
  margin: 20px auto 0;
  display: flex;
  justify-content: flex-end;
}
.wjt-bindbank-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  border-radius: 999px;
  border: 1px solid #c7dcd8;
  background: #fff;
  font-size: 14px;
  font-weight: 700;
  color: #007e7f;
  cursor: pointer;
  transition: background 0.2s;
}
.wjt-bindbank-btn:hover { background: #f3f9f8; }

/* 支付按钮区 */
.wjt-pay-action {
  margin-top: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.wjt-pay-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 48px;
  min-width: 210px;
  padding: 0 32px;
  border-radius: 999px;
  border: none;
  background: #009798;
  font-size: 16px;
  font-weight: 700;
  color: #fff;
  cursor: pointer;
  box-shadow: 0 12px 24px rgba(0, 151, 152,0.24);
  transition: all 0.2s;
}
.wjt-pay-btn:hover {
  transform: translateY(-2px);
  background: #007e7f;
}
.wjt-agreement {
  margin: 12px 0 0 0;
  font-size: 12px;
  color: #94a3b8;
}

/* 弹窗通用 */
.dialog-footer { margin-top: 50px; }
.dialog {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-left: 80px;
  padding-right: 80px;
}
.form-item { width: 100%; }
.dialog-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
}
#wjtWxQrCode {
  display: flex;
  align-items: center;
  justify-content: center;
}
.wjt-qr-refresh-text {
  margin-top: 16px;
  font-size: 14px;
  color: #94a3b8;
}
.wjt-qr-refresh-text > b {
  color: #009798;
  cursor: pointer;
}

/* 手机端适配 */
@media (max-width: 768px) {
  .wjt-pay-page { padding: 20px 16px 40px; }
  .wjt-pay-topbar { gap: 12px; margin-bottom: 20px; }
  .wjt-back-btn { height: 40px; padding: 0 18px; font-size: 14px; }
  .wjt-pay-title { font-size: 22px; }

  .wjt-pay-card { border-radius: 20px; }
  .wjt-pay-header {
    flex-direction: column;
    align-items: flex-start;
    padding: 24px 20px;
    gap: 16px;
  }
  .wjt-pay-header-left { gap: 12px; }
  .wjt-status-icon { width: 42px; height: 42px; font-size: 20px; }
  .wjt-status-text h2 { font-size: 18px; }
  .wjt-order-no { font-size: 13px; }
  .wjt-countdown { font-size: 13px; }
  .wjt-amount-box { text-align: left; padding: 10px 16px; align-self: stretch; }
  .wjt-amount-value { font-size: 28px; }

  .wjt-pay-body { padding: 24px 16px; }
  .wjt-section-title { margin-bottom: 20px; }
  .wjt-section-title h3 { font-size: 18px; }
  .wjt-method-card { padding: 16px; gap: 12px; }
  .wjt-method-icon { width: 40px; height: 40px; }
  .wjt-method-icon img { width: 22px; height: 22px; }
  .wjt-method-name { font-size: 15px; }
  .wjt-method-desc { font-size: 13px; }

  .wjt-bindbank-row { justify-content: center; }
  .wjt-pay-action { margin-top: 32px; }
  .wjt-pay-btn { height: 46px; min-width: 180px; font-size: 15px; }

  .dialog { padding-left: 20px; padding-right: 20px; }
}
</style>
